import { render, staticRenderFns } from "./quality-losses-tab.vue?vue&type=template&id=0c122ee7"
import script from "./quality-losses-tab.ts?vue&type=script&lang=js&external"
export * from "./quality-losses-tab.ts?vue&type=script&lang=js&external"
import style0 from "./quality-losses-tab.vue?vue&type=style&index=0&id=0c122ee7&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0c122ee7')) {
      api.createRecord('0c122ee7', component.options)
    } else {
      api.reload('0c122ee7', component.options)
    }
    module.hot.accept("./quality-losses-tab.vue?vue&type=template&id=0c122ee7", function () {
      api.rerender('0c122ee7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/operational-data/op-data-entry-details/tabs/quality-losses-tab/quality-losses-tab.vue"
export default component.exports